import IconeBemTeVi from '@/img/icones/IconeBemTeVi';
import { IconButton, Tooltip } from '@mui/material';

import React from 'react';
import RouterStore from '../store/RouterStore';

interface IPropsBemTeVi {

}


// @observer
export default class BemTeVi extends React.Component<IPropsBemTeVi> {
    abrirBemTeVi = () => {

        RouterStore.abrirJanela('https://bemtevi.tst.jus.br/');
    }

    render() {
        return (
            <Tooltip title='Abrir Bem-te-vi'>
                <div>
                    <IconButton onClick={this.abrirBemTeVi} aria-label='Abrir sistema Bem-te-vi. Irá abrir em uma nova janela.'>
                        <IconeBemTeVi />
                    </IconButton>
                </div>
            </Tooltip>
        );
    }
}
